import _ from 'lodash';

export default function screenReaderAnnounce(message) {

const divContent = document.getElementById('screenReaderExt');

if(!_.isUndefined (divContent) && !_.isNull(divContent)) {
     divContent.remove()
}

const liveRegion = document.createElement('div');

liveRegion.setAttribute('aria-live', 'polite');

liveRegion.setAttribute('role', 'alert')
liveRegion.id= 'screenReaderExt'
liveRegion.style.position = 'absolute';
liveRegion.style.left = '-9999px';
document.body.appendChild(liveRegion); 
liveRegion.textContent = message;

}